<template>
  <div class="limited-content" :style="{ maxHeight: `${height}px` }">
    <slot />

    <div
      class="limited-content__link"
      :style="{ top: `${height - LINE_HEIGHT + LINK_TOP_ADJUSTMENT}px` }"
    >
      <AppButton variation="link-accent" @click="emit('expand')">
        {{ t("common.expand") }}
      </AppButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import AppButton from "./app-button.vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  lineCount: number;
}>();

const emit = defineEmits<{
  (e: "expand"): void;
}>();

const { t } = useI18n();

const LINE_HEIGHT = 24;
const LINK_TOP_ADJUSTMENT = -1;

const height = computed(() => props.lineCount * LINE_HEIGHT);
</script>

<style lang="scss" scoped>
.limited-content {
  position: relative;
  overflow: hidden;

  &__link {
    position: absolute;
    right: 0;
    background: #fdfbf9;
    background: linear-gradient(
      to right,
      rgba(#fdfbf9, 0),
      rgba(#fdfbf9, 1) 3rem
    );
    padding-left: 3rem;
  }
}
</style>
